/* eslint-disable @typescript-eslint/no-var-requires */
const slug = require('./slugs');

const posters = [
  // 1
  {
    title:
      'DESCRIPCIÓN IMAGENOLÓGICA DEL CONDUCTO RETROMOLAR. REPORTE DE CASO Y REVISIÓN DE LA LITERATURA',
    showDate: false,
    authors: [
      {
        name: 'Sosa Darío',
        tag: 'Profesor del Departamento de Investigación. Facultad de Odontología, Universidad de Los Andes',
      },
      {
        name: 'Paolini Omar',
        tag: 'Profesor de la Cátedra de Imagenología Oral y Maxilofacial. Facultad de Odontología, Universidad de Los Andes',
      },
    ],
    keywords: [
      'conducto retromolar',
      'foramen retromolar',
      'tomografía computarizada de haz cónico',
      'odontología',
    ],
    youtube: 'jBEUCya68QM',
    resumen:
      'El conducto retromolar es una variación anatómica ubicada posterior al tercer molar mandibular en el trígono retromolar. Su importancia en Odontología radica en el contenido del paquete neurovascular, el cual debe ser tomado en cuenta a la hora de realizar procedimientos quirúrgicos como extracción de terceros molares, toma de injertos en zona retromolar y osteotomías sagitales, entre otros. Desde el punto de vista imagenológico, puede ser observado a través de la tomografía computarizada de haz cónico y en menor proporción, en radiografías panorámicas, debido a su posición y tamaño reducidos. En el presente caso, se describen las características de un conducto retromolar de una paciente femenina de 69 años de edad, a la que le fue detectado a través de tomografía computarizada de haz cónico un conducto retromolar en lado izquierdo, tipo A2 según la clasificación de Patil et al. de 12,39mm de largo desde su emergencia del canal mandibular, entre 0.84 y 1.83mm de diámetro en sentido anteroposterior, y un foramen retromolar de 1.91mm en sentido vestíbulo lingual y 1,19mm en sentido antero posterior. El conocimiento de este detalle anatómico a la hora del abordaje quirúrgico de la zona permitirá evitar daños al paquete neurovascular y sus consecuencias postoperatorias.',
  },
  // 2
  {
    title:
      'CONFIABILIDAD DIAGNÓSTICA DEL TRAZADO TOTALMENTE AUTOMATIZADO CON WEBCEPH™',
    showDate: false,
    authors: [
      {
        name: 'Gallardo López Edna A',
        tag: 'Odontólogo. Residente del Postgrado de Ortopedia Dentofacial y Ortodoncia. Facultad de Odontología. Universidad de Carabobo. Valencia, Venezuela. ORCID 0000-0002-3312-1939',
      },
      {
        name: 'Mejías Rotundo Oswaldo',
        tag: 'Candidato a Doctor en Odontología. Facultad de Odontología. Universidad Central de Venezuela. ORCID 0000-0002-6109-3912',
      },
    ],
    keywords: [
      'Confiabilidad',
      'cefalometría',
      'web',
      'Inteligencia Artificial',
      'Ortodoncia',
    ],
    youtube: 'HoR_o1ljThY',
    resumen:
      'Introducción: En el análisis cefalométrico totalmente automatizado una inteligencia artificial (AI) sustituye al hombre en la localización de puntos y cálculo del procedimiento. Su confiabilidad depende de la precisión en la localización más el acuerdo y equivalencia entre ella y el usuario. El objetivo será evaluar la confiabilidad diagnóstica de los trazados automatizados al ser comparados con el usuario. Materiales y métodos: Estudio descriptivo transversal no experimental. En 44 radiografías se evaluaron los ángulos: SNA, SNB, ANB, FMA y SN-GoGn. El usuario bajo estudio (EG) posee un año de experiencia en trazados asistidos por computadora. Se evaluaron tres aspectos: a) distribución de modificaciones en los puntos por el usuario; b) ICC con dos vías para efecto aleatorio de tipo evaluador simple con acuerdo absoluto; c) equivalencia por prueba de dos colas con un límite preestablecido de 2º. Resultados: Nasion (n=12) y B (n=13) fueron los más modificados. El ICC varió entre 0.761 a 0.927 mientras que hubo equivalencia en todos los ángulos (promedio de diferencias entre -0.61 a 0.72º). Conclusión: El trazado totalmente automatizado es una herramienta confiable.',
  },
  // 3
  {
    title:
      'DESCOMPRESIÓN, PRIMERA LÍNEA DE TRATAMIENTO PARA LESIONES QUÍSTICAS DE LA MANDÍBULA. PRESENTACIÓN DE CASO CLÍNICO',
    showDate: false,
    authors: [
      {
        name: 'Herrera Dimas J',
        tag: 'Odontólogo Universidad Gran Mariscal de Ayacucho, Barcelona- Venezuela. Residente del Postgrado de Cirugía Bucal ULAC-IDOLA',
      },
      {
        name: 'Quintero Jennifer E',
        tag: 'Odontólogo Universidad Santa María, Caracas-Venezuela. Residente del Postgrado de Cirugía Bucal ULAC-IDOLA',
      },
      {
        name: 'Castellanos María J',
        tag: 'Odontólogo Universidad José Antonio Páez,Valencia-Venezuela. Residente del Postgrado de Cirugía Bucal ULAC-IDOLA',
      },
      {
        name: 'López Braulio',
        tag: 'Odontologo Universidad de Carabobo. Cirujano Bucal y Maxilofacial Ciudad Hospitalaria Dr. Henrique Tejera. Profesor Adjunto al Postgrado de Cirugía Bucal ULAC-IDOLA.',
      },
    ],
    keywords: [
      'Quistes odontogénicos',
      'mandíbula',
      'queratoquiste odontogénico',
      'tomografía computarizada de haz cónico',
    ],
    tagLine:
      'Universidad Latinoamericana y del Caribe (ULAC). Instituto Docente Odontológico López Arévalo (IDOLA) Programa de especialización en cirugía bucal, Valencia, Venezuela.',
    youtube: 'u_qD3wa35-Q',
    resumen:
      'Las lesiones quísticas ocurren frecuentemente en los maxilares, principalmente debido a la presencia de células que son remanentes del neuroectodermo embrionario. La descompresión es una técnica conservadora cuyo objetivo es disminuir la presión intraquística mediante un drenaje constante, permitiendo el crecimiento de nuevo hueso centrípeto de las paredes óseas del quiste. Se describe un caso de lesión quística mandibular en paciente masculino de 27 años de edad que acude a consulta por presentar secreción purulenta en mucosa trígono retromolar de UD 37, paciente asintomático al momento de la consulta. La evaluación mediante tomografía computarizada de haz cónico revela imagen hipodensa de bordes definidos localizada en límite posterior de cuerpo mandibular, borde anterior y parte de la rama ascendente mandibular del lado izquierdo; que se extiende en sentido cefálico caudal desde la cresta alveolar y borde anterior de la rama hasta la cortical superior del conducto mandibular. El diagnóstico diferencial es quiste periapical quiste residual y  ameloblastoma. Se realiza biopsia incisional de la lesión y se envía para su estudio histopatológico y se realiza descompresión con dispositivo personalizado, actualmente en proceso.',
  },
  // 4
  {
    title:
      'CUIDADOS PALIATIVOS DE CARCINOMA EPIDERMOIDE MANDIBULAR REPORTE DE CASO CLÍNICO.',
    showDate: false,
    authors: [
      {
        name: 'Díaz Félix L',
        tag: 'Odontólogo Universidad Central de Venezuela. Distrito Capital. Residente de postgrado de Cirugía Bucal IDOLA-ULAC.',
      },
      {
        name: 'Velásquez Aransa M',
        tag: 'Odontólogo Universidad Gran Mariscal de Ayacucho. Barcelona. Edo. Anzoátegui. Residente de postgrado Cirugía Bucal IDOLA-ULAC',
      },
      {
        name: 'Quintero Jennifer E',
        tag: 'Odontólogo Universidad Santa María. Distrito Capital. Residente de postgrado de Cirugía Bucal IDOLA-ULAC.',
      },
      {
        name: 'López Heriberto J',
        tag: 'Odontólogo Universidad de Carabobo. Cirujano Bucal y Maxilofacial. Adjunto al postgrado de Cirugía Bucal IDOLA-ULAC.',
      },
    ],
    keywords: ['carcinoma epidermoide', 'cuidados paliativos'],
    tagLine:
      'Universidad Latinoamericana y del Caribe (ULAC). Instituto Docente Odontológico López Arévalo (IDOLA) Programa de especialización en cirugía bucal, Valencia, Venezuela.',
    youtube: 'h97LjiqS1KE',
    resumen:
      'El carcinoma epidermoide es una neoplasia maligna que se origina de la capa más superficial de células escamosas del epitelio. Es la neoplasia más frecuente de la cavidad bucal. Ésta presenta un crecimiento agresivo, con invasión rápida de los tejidos. Se presenta el caso de una paciente de 73 años de edad diagnosticada con carcinoma epidermoide mandibular, ante la evaluación clínica se aprecia asimetría facial a expensas de hemicara derecha donde se evidencia aumento de volumen hemimandibular ipsilateral, en TC cone beam se aprecia imagen hipodensa heterogénea hemimandibular derecha condicionando así una pérdida de la continuidad mandibular que abarca la zona antero inferior (Parasinfisiaria), cuerpo derecho, ángulo de la mandíbula  llegando incluso a la rama ascendente  y en sentido céfalo caudal desde la cresta alveolar hasta la basal mandibular ipsilateral observándose erosión de la tabla vestibular, se reportan los cuidados paliativos que circundan al paciente en cuestión como alcance de las terapéuticas impartidas por el cirujano bucal razón por la cual se decide reportar su tratamiento y evolución, haciendo especial énfasis en el manejo paliativo.',
  },
  // 5
  {
    title: 'PRESENTACIÓN INUSUAL DE UN QUISTE RADICULAR: REPORTE DE UN CASO.',
    showDate: false,
    authors: [
      {
        name: 'Chourio Francisco J',
        tag: 'Residente del Postgrado de Cirugía y Traumatología Bucal y Maxilofacial del Hospital General del Oeste “Dr. José Gregorio Hernández”..',
      },
      {
        name: 'Vargas Alfredo',
        tag: 'Residente del Postgrado de Cirugía y Traumatología Bucal y Maxilofacial del Hospital General del Oeste “Dr. José Gregorio Hernández”.',
      },
      {
        name: 'Gómez Xiomara A',
        tag: 'Odontólogo especialista en Endodoncia.',
      },
      {
        name: 'Manresa Carlos',
        tag: 'Profesor del Postgrado de Cirugía y Traumatología Bucal y Maxilofacial del Hospital General del Oeste “Dr. José Gregorio Hernández.',
      },
    ],
    keywords: [
      'Quiste odontogénico',
      'quiste radicular',
      'quiste inflamatorio.',
    ],
    tagLine: '',
    youtube: 'dkby5cgeZJs',
    resumen:
      'El quiste radicular (QR), considerado por la OMS como un quiste odontogénico de origen inflamatorio, se origina de los restos de malassez y es el más común de los quistes odontogénicos (55%). Los QR se observan radiográficamente como una imagen radiolúcida, unilocular, bien definida y circunscrita con borde radiopaco, asociado al ápice de un órgano dental no vital, de aproximadamente 1-2 cm de diámetro. Las pruebas pulpares, radiográficas y la evaluación histopatológica son útiles para lograr un diagnóstico preciso. 1-12 Se trata de paciente femenino de 16 años de edad, quien refiere fístula en cuadrante III de 5 años de evolución sin tratamiento. Hace 8 meses acude a ortodoncista quien identifica lesión en radiografía (rx) panorámica y refiere a nuestro servicio. Clínicamente se evidencia fístula con contenido purulento a nivel de encía adherida del 3.5. Se indica tomografía computarizada de haz cónico donde se observa una imagen hipodensa de forma irregular de 2,8x1,9 cm, asociada a la unidad dentaria (UD) 3.5 que se extiende desde el ápice de laUD 3.4 hasta la UD3.6,y en relación con el canal mandibular. Se refiere a endodoncista quien realiza tratamiento para cierre apical y obturación del mismo. Se realizó biopsia excisional, la cual concluyó Quiste Radicular. A las 10 semanas se evalúa rx panorámica, donde se observa que en el espacio donde se ubicaba la lesión, el tejido presenta características similares al del hueso circundante, de igual forma se aprecia imagen radiolúcida bien definida de 10mm a nivel del ápice de OD 3.5 correspondiente con la ventana quirúrgica. Se concluye que el quiste radicular es más común en los maxilares y la literatura coincide en que suele tener un forma redondeada y un tamaño que oscila entre 1 y 2 cm, siempre asociado a un diente no vital. En nuestro caso presentó un tamaño mayor y de forma bastante irregular por lo que se manejaron varios diagnósticos diferenciales. Sin embargo, las pruebas de vitalidad, los estudios de imagen y la histopatología permitieron confirmar su diagnóstico. El manejo interdisciplinario en estos casos es imprescindible para la correcta resolución del mismo.',
  },
  // 6
  {
    title:
      'SEGUIMIENTO DE LAS ETAPAS DE REGENERACIÓN ÓSEA POST MARSUPIALIZACIÓN DE UN QUERATOQUISTE LUEGO DE 48 MESES',
    showDate: false,
    authors: [
      {
        name: 'Vinatea Cuenca de Figueroa María T',
        tag: 'Programa de Especialización en Radiología Bucal y Maxilofacial, Universidad Peruana Cayetano Heredia, Perú.',
      },
      {
        name: 'Chacón de Velasco Sheyla F',
        tag: 'Programa de Especialización en Radiología Bucal y Maxilofacial, Universidad Peruana Cayetano Heredia, Perú.',
      },
      {
        name: 'Quezada Márquez Milushka Miroslava',
        tag: 'Programa de Especialización en Radiología Bucal y Maxilofacial, Universidad Peruana Cayetano Heredia, Perú.',
      },
      {
        name: 'Celis Contreras César',
        tag: 'Programa de Especialización en Imagenología Oral y Maxilofacial, Universidad de Talca, Chile.',
      },
    ],
    keywords: [
      'Regeneración ósea',
      'estudios de seguimiento',
      'radiografía panorámica',
      'quistes odontogénicos.',
    ],
    tagLine: '',
    youtube: 'dsEyXQItl_A',
    resumen:
      'El queratoquiste odontogénico según la OMS está clasificado dentro de los quistes del desarrollo. La marsupialización es una técnica muy usada en el tratamiento del queratoquiste odontogénico. Kawai et al (1995) mostraron la secuencia de cambios en la regeneración ósea post marsupialización de quistes y tumores mediante radiografías panorámicas. Los cambios en la estructura interna comprende 4 etapas: (1) sin cambios, (2) patrón de vidrio esmerilado en la periferia, (3) patrón espiculado en la periferia y de vidrio esmerilado en la zona central y (4) aspecto trabecular como señal de cicatriz ósea. Presentamos el caso de un paciente masculino de 56 años, que acude a control radiográfico 4 años después de someterse a la marsupialización de un queratoquiste, localizado en cuerpo mandibular derecho. La comparación de la radiografía panorámica inicial con 3 controles radiográficos posteriores, obtenidos a los 3 meses, 7 meses y 4 años post marsupialización, nos permiten ilustrar la secuencia de regeneración ósea descritas en el artículo histórico de Kawai. El presente caso nos permite ilustrar las 4 etapas de regeneración ósea, gracias al control radiográfico de un mismo paciente a través de radiografías panorámicas.',
  },
  // 7
  {
    title: 'OSTEOPENIA Y OSTEOMIELITIS DE LOS MAXILARES: REPORTE DE CASO',
    showDate: false,
    authors: [
      {
        name: 'Chacón de Velasco Sheyla F',
        tag: 'Universidad Peruana Cayetano Heredia – Perú.',
      },
      {
        name: 'Rojas Chuquín Jhonnathan D',
        tag: 'Universidad Peruana Cayetano Heredia – Perú.',
      },
      {
        name: 'Ruiz García de Chacón Vilma E',
        tag: 'Universidad Peruana Cayetano Heredia – Perú.',
      },
      {
        name: 'Hidalgo Rivas Alejandro',
        tag: 'Programa de Especialización en Imagenología Oral y Maxilofacial, Universidad de Talca, Chile.',
      },
    ],
    keywords: [
      'Osteoporosis',
      'radiografía panorámica',
      'densidad ósea',
      'Osteomielitis',
    ],
    tagLine: '',
    youtube: 'Kas9_0lju5o',
    resumen:
      'La osteopenia es una condición sistémica caracterizada por baja densidad ósea, donde existe un desequilibrio entre osteoblastos y osteoclastos, con tendencia a la resorción. Condiciona alteraciones óseas y predispone a osteomielitis. Puede presentarse en ambos sexos y en diversos rangos etarios, pero afecta más a mujeres post menopaúsicas. Los factores de riesgo tales como edad, sexo, consumo de bifosfonatos, inadecuado consumo de calcio y alteraciones endocrinas condicionan la severidad de los casos. Se presenta el caso de mujer de 77 años con antecedentes de hipertensión arterial, hipotiroidismo y consumo de bifosfonatos, refiere dolor y secreción purulenta a nivel de pieza 23, la cual fue extraída. La secreción no cesó y presentó retardo en la cicatrización. A la evaluación imagenológica, se observan alteraciones en la estructura ósea. El resultado anatomopatológico fue Osteomielitis Supurativa Crónica. En base al artículo de Klemetti (1994) se puede contrastar este caso con signos imagenológicos sugerentes de osteopenia, siendo esta la principal causa del retraso en la reparación ósea de la zona. Se realizó un seguimiento radiográfico durante 15 meses, observando cambios favorables en el trabeculado y estructuras óseas. Se concluye que condiciones sistémicas como la osteopenia pueden favorecer cuadros infecciosos tornándolos crónicos, asimismo perjudican procesos fisiológicos como la reparación ósea.',
  },
  // 8
  {
    title:
      'EVALUACIÓN IMAGENOLÓGICA DE UNA ANQUILOSIS FALSA DE LA ARTICULACIÓN TEMPOROMANDIBULAR',
    showDate: false,
    authors: [
      {
        name: 'Rojas Chuquín Jhonnathan D',
        tag: 'Programa de Especialización en Radiología Bucal y Maxilofacial, Universidad Peruana Cayetano Heredia, Perú.',
      },
      {
        name: 'Vinatea Cuenca de Figueroa María T',
        tag: 'Programa de Especialización en Radiología Bucal y Maxilofacial, Universidad Peruana Cayetano Heredia, Perú.',
      },
      {
        name: 'Calderón Ubaqui Víctor',
        tag: 'Programa de Especialización en Radiología Bucal y Maxilofacial, Universidad Peruana Cayetano Heredia, Perú.',
      },
      {
        name: 'Hidalgo Rivas Alejandro',
        tag: 'Programa de Especialización en Imagenología Oral y Maxilofacial, Universidad de Talca, Chile.',
      },
    ],
    keywords: [
      'Anquilosis',
      'articulación temporomandibular',
      'tomografía computarizada de haz cónico.',
    ],
    tagLine: '',
    youtube: 'hZWVLSrVFHA',
    resumen:
      'La anquilosis de articulación temporomandibular (ATM) se clasifica como verdadera si su origen está relacionado directamente con la articulación y de tipo falsa, relacionada a estructuras ajenas a los componentes de la ATM. Ambos tipos comparten signos y síntomas representando un desafío en su diagnóstico. Se reporta el caso de mujer de 44 años, consulta por dolor y apertura bucal disminuida. Refiere que a los 9 años de edad sufrió un fuerte proceso infeccioso en la cara, lo que requirió injertos de piel. Sin embargo, la infección no cesó y por casi un año continuó presentando drenaje de material purulento, paralelo a lo cual fue notando la disminución de la apertura bucal. La radiografía panorámica mostró asimetría y extrusión dentoalveolar de las piezas 46 y 47. En la tomografía computarizada de haz cónico (TCHC) encontramos una fusión de la apófisis pterigoides del lado derecho con la rama mandibular ipsilateral. Se concluye quesi bien lo más común al pensar en anquilosis de la ATM es relacionarla directamente con una afección del cóndilo, es importante recordar que también podemos encontrar este tipo de anquilosis falsa. La TCHC tiene un alto valor diagnóstico para definir el tipo de anquilosis.',
  },
  // 9
  {
    title:
      'REABSORCIÓN CERVICAL INVASIVA, IMPORTANCIA DE UN DIAGNÓSTICO IMAGENOLÓGICO OPORTUNO. REPORTE DE UN HALLAZGO RADIOGRÁFICO.',
    showDate: false,
    authors: [
      {
        name: 'Amigo Vásquez Susana E',
        tag: 'Programa de Especialización en Imagenología Oral y Maxilofacial, Universidad de Talca, Chile.',
      },
      {
        name: 'Quintanilla Sfeir Miguel A',
        tag: 'Programa de Especialización en Imagenología Oral y Maxilofacial, Universidad de Talca, Chile.',
      },
      {
        name: 'Zapata Fuente-Alba Karla V',
        tag: 'CEMOL Imagenología Maxilofacial, Centro de Especialidades Médicas y Odontológicas Linares, Chile.',
      },
      {
        name: 'Hidalgo Rivas Alejandro',
        tag: 'Programa de Especialización en Imagenología Oral y Maxilofacial, Universidad de Talca, Chile.',
      },
    ],
    keywords: [
      'Endodoncia',
      'tomografía computarizada de haz cónico',
      'reabsorción radicular.',
    ],
    tagLine: '',
    youtube: '5nGrT-leJ8w',
    resumen:
      'La Reabsorción cervical invasiva (RCI) es un término clínico que describe un tipo de reabsorción radicular externa poco común, de crecimiento lento, gradual, asintomático y localmente agresivo. Se desconoce su etiología, aunque se han identificado algunos factores predisponentes, como tratamientos de ortodoncia o trauma dentoalveolar. Existen clasificaciones tanto en radiografías periapicales como en tomografía computarizada de haz cónico (TCHC). Debido a su variabilidad de forma y extensión, actualmente se recomienda un examen de TCHC previo a una decisión terapéutica. Se reporta el caso de paciente sexo femenino, 29 años, acude a control radiográfico posterior a retiro de aparatología de ortodoncia. En radiografía panorámica y periapical de diente 1.1 se observa una extensa imagen radiolúcida sobreproyectada con cámara pulpar y conducto. Al complementar con TCHC se evidencia una extensa imagen hipodensa, de límites definidos y forma irregular, rodeando al conducto radicular hasta su tercio apical. Se estableció el diagnóstico de RCI. Se concluye que la TCHC permite dimensionar el real compromiso de los dientes afectados con RCI y tomar una mejor decisión de tratamiento. Es importante identificar la RCI tempranamente para realizar un tratamiento oportuno, ya que el tratamiento en etapas avanzadas podría llegar a la exodoncia.',
  },
  // 10
  {
    title:
      'PÓLIPO ANTROCOANAL AGRESIVO: DIAGNÓSTICO A PARTIR DE UN HALLAZGO EN RADIOGRAFÍA PANORÁMICA. REPORTE DE UN CASO.',
    showDate: false,
    authors: [
      {
        name: 'Costa Trucco Camila A',
        tag: 'Programa de Especialización en Imagenología Oral y Maxilofacial, Universidad de Talca, Chile.',
      },
      {
        name: 'Fuentealba Muñoz Claudio A',
        tag: 'Programa de Especialización en Imagenología Oral y Maxilofacial, Universidad de Talca, Chile.',
      },
      {
        name: 'Quintanilla Sfeir Miguel A',
        tag: 'Programa de Especialización en Imagenología Oral y Maxilofacial, Universidad de Talca, Chile.',
      },
      {
        name: 'Hidalgo Rivas Alejandro',
        tag: 'Programa de Especialización en Imagenología Oral y Maxilofacial, Universidad de Talca, Chile.',
      },
    ],
    keywords: [
      'Seno maxilar',
      'hallazgos incidentales',
      'radiografía panorámica',
      'tomografía computarizada de haz cónico.',
    ],
    tagLine: '',
    youtube: 'VGTtZlyzMrU',
    resumen:
      'El pólipo antrocoanal (PAC) es una neoplasia benigna que produce el crecimiento pedunculado de la mucosa del seno maxilar. Se diagnostica mediante endoscopía nasal y tomografía computarizada. Imagenológicamente se observa una masa hipodensa de tejido blando que ocupa seno maxilar y meato medio hasta las coanas. El tratamiento es la remoción quirúrgica y su recurrencia es poco frecuente. Se reporta el caso de mujer, 13 años, sin antecedentes médicos relevantes, acude a control odontológico general. En radiografía panorámica, como hallazgo incidental se observa una alteración de radiotransparencia en seno maxilar izquierdo y una posición ectópica del diente 2.8. En tomografía computarizada de haz cónico se evidencia una extensa lesión hipodensa que compromete completamente el seno maxilar izquierdo sin expansión de corticales, invade cavidad nasal a nivel de meato medio, destruye la concha nasal media, y se extiende hacia posterior. Se deriva a otorrinolaringología donde se confirma el diagnóstico de PAC. Se concluye que el PAC es una neoplasia benigna que puede ser localmente agresiva, y presentar características poco habituales como la destrucción de la concha nasal media. A pesar su presentación asintomática, un diagnóstico sistemático en radiografía panorámica puede evidenciar signos secundarios que den indicio de la presencia de patologías como el PAC.',
  },
  // 11
  {
    title:
      'AMELOBLASTOMA CONVENCIONAL LA IMPORTANCIA DEL ESTUDIO IMAGENOLÓGICO Y EL CONTROL RADIOGRÁFICO PERIÓDICO. REPORTE DE CASO',
    showDate: false,
    authors: [
      {
        name: 'Morantes Peña Paola',
        tag: 'Programa de Especialización en Imagenología Oral y Maxilofacial, Universidad de Talca, Chile.',
      },
      {
        name: 'Duran Montero Francisca A',
        tag: 'Programa de Especialización en Imagenología Oral y Maxilofacial, Universidad de Talca, Chile.',
      },
      {
        name: 'Amigo Vásquez Susana E',
        tag: 'Programa de Especialización en Imagenología Oral y Maxilofacial, Universidad de Talca, Chile.',
      },
      {
        name: 'Celis Contreras César E',
        tag: 'Programa de Especialización en Imagenología Oral y Maxilofacial, Universidad de Talca, Chile.',
      },
    ],
    keywords: [
      'Ameloblastoma',
      'tumor odontogénico',
      'radiología',
      'control radiográfico',
      'recidiva.',
    ],
    tagLine: '',
    youtube: 'ecd2yTCPX7A',
    resumen:
      'El ameloblastoma es el tumor odontogénico epitelial benigno más frecuente de los maxilares, caracterizado por su agresividad local y alta tasa de recidiva. Se presenta como un aumento de volumen indoloro, de crecimiento lento, y radiográficamente como una lesión radiolúcida expansiva con márgenes definidos y corticalizados de apariencia uni o multilocular. Puede desplazar dientes y producir rizálisis. Para su diagnóstico, es importante la epidemiologia y la clínica, junto a un buen estudio imagenológico. Se reporta el caso de mujer de 53 años con aumento de volumen mandibular izquierdo de 3 meses de evolución. En los exámenes radiográficos se observa imagen radiolúcida multilocular extensa en cuerpo mandibular izquierdo de límites netos corticalizados con expansión de corticales. Se realiza resección mandibular parcial con márgenes de seguridad e injerto óseo y se deriva a biopsia donde se confirma el diagnóstico de ameloblastoma. Se hace seguimiento con controles radiográficos a los dos y ocho años, donde presenta recidiva en el último control post tratamiento. El presente caso muestra un ameloblastoma con recidiva tardía y alta agresividad local. La literatura señala que se deben realizar controles radiográficos postquirúrgicos hasta por 5 años, pero en base al presente caso, se sugiere que sean periódicos y permanentes.',
  },
  // 12
  {
    title:
      'DISPLASIA FIBROSA MAXILAR. DEL DIAGNÓSTICO AL TRATAMIENTO. REPORTE DE CASO.',
    showDate: false,
    authors: [
      {
        name: 'Córdova Carla F',
        tag: 'Odontólogo Universidad José Antonio Páez. Residente del Postgrado de Cirugía Bucal ULAC-IDOLA.',
      },
      {
        name: 'Briceño Jorge I',
        tag: 'Odontólogo Universidad de Los Andes. Residente del Postgrado de Cirugía Bucal ULAC-IDOLA.',
      },
      {
        name: 'Quintero Jennifer E',
        tag: 'Odontólogo Universidad Santa María. Residente del Postgrado de Cirugía Bucal ULAC-IDOLA.',
      },
      {
        name: 'López Braulio H',
        tag: 'Odontólogo Universidad de Carabobo. Cirujano Maxilofacial Ciudad Hospitalaria Dr Henrique Tejera. Profesor Adjunto del Postgrado de Cirugía Bucal ULAC-IDOLA',
      },
    ],
    keywords: ['Displasia fibrosa', 'benigna', 'maxilar', 'cirugía'],
    tagLine:
      'Instituto Docente Odontológico López Arévalo (IDOLA). Universidad Latinoamericana y del Caribe (ULAC) Programa de Especialización en Cirugía Bucal. Valencia, Venezuela.',
    youtube: 'cbGYlV2hJhQ',
    resumen:
      'El término Displasia fibrosa hace referencia a un conjunto de lesiones óseas benignas que se caracterizan por la sustitución del tejido óseo normal por tejido conectivo fibroso, debido a una alteración funcional de las células debido a una mutación en el gen GNAS provocando el reemplazo del tejido óseo por fibroóseo. Se presenta el caso de un paciente adolescente de género masculino, afectado por displasia fibrosa en hemimaxilar derecho, a quien le fueron realizados los estudios imagenológicos e histopatológicos necesarios para obtener el diagnóstico definitivo y decidir el abordaje menos invasivo cumpliendo con sus estándares de estética facial. Se realiza abordaje intra oral para shaving óseo, con sedación consciente bajo estricta vigilancia de la especialista en anestesiología, una vez logrado el contorno deseado mediante el uso de piezas de mano de alta y baja velocidad, se realiza la sutura de los tejidos y el paciente egresa deambulante y con buen estado general de salud. Se concluye la pertinencia de los estudios y procedimientos que fueron llevados a cabo para determinar el manejo del paciente, desde el diagnóstico hasta la realización del tratamiento, enfatizando la importancia del control clínico y radiográfico post operatorio pertinente en este tipo de casos.',
  },
  // 13
  {
    title: 'IMAGENOLOGÍA Y REPORTE DE CASO DE QUISTE DEL CONDUCTO TIROGLOSO',
    showDate: false,
    authors: [
      {
        name: 'Bascuñán Catalina',
        tag: 'Universidad de los Andes, Departamento de Imagenología Oral y Maxilofacial.',
      },
      {
        name: 'Concha Guillermo',
        tag: 'Universidad de los Andes, Departamento de Imagenología Oral y Maxilofacial.',
      },
    ],
    keywords: ['Tomografía computarizada', 'quiste xonducto tirogloso'],
    tagLine: '',
    youtube: 'QYXZOScGbH4',
    resumen:
      'El quiste del conducto tirogloso corresponde a la lesión cervical congénita más frecuente, producida por una alteración del desarrollo por falta de involución del conducto de descenso de la glándula tiroides. Esta se presenta como una masa de ubicación cervical paramediana o en línea media, asintomática, de tamaño variable, habitualmente 2 a 4 cm de diámetro, y es de forma redondeada u ovoide. Epidemiológicamente el 90% se presenta en menores de 10 años, mientras que un 10% se puede observar en pacientes de 20 a 35 años. Respecto a sus características imagenológicas se observa como una masa quística cervical de línea media de aspecto benigno, que puede presentar su pared realzada con contraste si presenta infección. En TC se observa como una masa de baja densidad, ocasionalmente tabicada, mientras que en RM se observa de baja intensidad en imágenes en T1 y alta intensidad en imágenes en T2. Los diagnósticos diferenciales a considerar son tiroides lingual, linfadenopatías y dermoide lingual. En este trabajo se presenta un reporte de caso de una paciente de sexo femenino, de 27 años a quien se le realizó un examen de tomografía computarizada para estudiar una lesión compatible con un quiste del conducto tirogloso.',
  },
  // 14
  {
    title: 'ODONTOMA COMPUESTO. REPORTE DE CASO',
    showDate: false,
    authors: [
      {
        name: 'Velozo Galeano Mónica L',
        tag: 'Facultad de Odontología- Universidad Nacional del Nordeste. Corrientes. Argentina.',
      },
      {
        name: 'Romero Marisa E',
        tag: 'Facultad de Odontología- Universidad Nacional del Nordeste. Corrientes. Argentina.',
      },
      {
        name: 'Jacob Rubén A',
        tag: 'Facultad de Odontología- Universidad Nacional del Nordeste. Corrientes. Argentina.',
      },
      {
        name: 'Velozo Cardozo Diego',
        tag: 'Facultad de Odontología- Universidad Nacional del Nordeste. Corrientes. Argentina.',
      },
    ],
    keywords: ['Tumores odontogenicos', 'odontoma compuesto'],
    tagLine: '',
    youtube: '',
    resumen:
      'Los tumores odontogénicos son lesiones mixtas, desde el punto de vista radiográfico, que derivan de restos epiteliales y mesenquimatosos del órgano del esmalte, por lo que su localización es exclusivamente en los maxilares. Los odontomas Son los tumores odontogénicos más comunes. Representan el 51%. Se caracterizan por la formación de esmalte, dentina, cemento y tejido pulpar. Su etiología es desconocida, se relaciona a factores traumáticos, infecciosos o genéticos. De crecimiento lento, asintomático, no agresivo. Generalmente interfieren en la erupción de algunas piezas dentarias. Tratamiento: quirúrgico, conservador. Recurrencia poco probable. Odontoma compuesto: se caracterizan por la formación de dentículos. Ubicación más frecuente en sector antero superior. Odontoma complejo: se presentan como masas amorfas, formadas por tejidos dentarios. Ubicación más frecuente es en el sector posterior. Se presenta caso clínico de paciente sexo femenino, 35 años de edad. En la radiografía panorámica se observa lesión mixta. Estructuras radiopacas como pequeños dientes de forma conoidea, rodeadas de halo radiolúcido en sector antero inferior. En la tomografía computada de haz cónico se visualiza lesión mixta: áreas hiperdensas e hipodensas. Dentículos entre piezas dentarias 32 y 33. Vinculable a odontoma compuesto. Se concluye la importancia de realizar el diagnostico imagenológico en estadios tempranos para evitar largos tratamientos correctivos.',
  },
  // 15
  {
    title:
      'CARACTERÍSTICAS BIOMÉTRICAS SE LA SILLA TURCA MEDIANTE TELERRADIOGRAFÍA DE PERFIL EN PACIENTES DEL SERVICIO DE IMAGENOLOGÍA DE LA UNIVERSIDAD FINIS TERRAE',
    showDate: false,
    authors: [
      {
        name: 'Pinto Daniel A',
        tag: 'Postítulo de Imagenología Oral y Maxilofacial Universidad Finis Terrae.',
      },
      {
        name: 'Davanzo Soledad S',
        tag: 'Postítulo de Imagenología Oral y Maxilofacial Universidad Finis Terrae.',
      },
      {
        name: 'González Mariana A',
        tag: 'Postítulo de Imagenología Oral y Maxilofacial Universidad Finis Terrae.',
      },
    ],
    keywords: ['Silla turca', 'morfología', 'radiografía.'],
    tagLine: '',
    youtube: '6pLK5yA02QY',
    resumen:
      'La silla turca es una estructura importante en el análisis radiográfico del complejo craneofacial. El punto fosa es una referencia para el estudio diagnóstico del crecimiento de un individuo y durante la evaluación del tratamiento. El objetivo de esta investigación fue analizar el tamaño y forma de la fosa hipofisaria mediante telerradiografías de perfil en pacientes del servicio de imagenología de la Universidad Finis Terrae. La población objetivo fueron pacientes entre 14 y 61 años atendidos en el servicio de imagenología de la Universidad Finis Terrae. Se realizó un estudio de tipo observacional descriptivo, de corte transversal. Concluyendo que no se evidencian diferencias significativas en cuanto al tamaño de la fosa hipofisaria para ambos sexos y grupos etarios considerados, en referencia a la forma, la oval fue la más prevalentey en consideración al tamaño de la fosa, las 3 medidas (longitud, diámetro y profundidad) presentaron valores muy similares considerando edad y sexo. Se sugiere realizar un estudio en 3D que pudiera entregar información complementaria en evaluación de área y volumen al estudio 2D.De igual manera, se sugiere evaluar una cuarta clasificación, forma cuadrangular, debido a que algunas geometrías de la fosa que se visualizaron están fuera de la norma descrita.',
  },
  // 16
  {
    title: 'QUERATOQUISTE ODONTOGÉNICO REPORTE DE CASO CLÍNICO',
    showDate: false,
    authors: [
      {
        name: 'Amaris Aroldo A',
        tag: 'Odontólogo Universidad Nacional Experimental Rómulo Gallegos, San Juan de Los Morros- Venezuela. Residente del Postgrado Cirugía Bucal IDOLA-ULAC.',
      },
      {
        name: 'Castellanos María J',
        tag: 'Odontólogo Universidad Jose Antonio Páez, San Diego - Venezuela. Residente del Postgrado de Cirugía Bucal IDOLA-ULAC.',
      },
      {
        name: 'Córdova Carla C',
        tag: 'Odontólogo Universidad Jose Antonio Páez, San Diego- Venezuela. Residente del Postgrado de Cirugía Bucal IDOLA-ULAC.',
      },
      {
        name: 'López Heriberto J',
        tag: 'Odontología Universidad de Carabobo. Cirujano Bucal y Maxilofacial CHET y HUAL. Profesor Adjunto al Postgrado de Cirugía Bucal IDOLA-ULAC.',
      },
    ],
    keywords: [
      'Queratoquiste odontogénico',
      'descompresión',
      'enucleación',
      'tomografía cone beam',
      'dispositivo.',
    ],
    tagLine:
      'Universidad Latinoamericana y del Caribe (ULAC) Instituto Docente López Arévalo (IDOLA). Programa de especialización en Cirugía Bucal Valencia, Venezuela.',
    youtube: 'HITwxIWP7x8',
    resumen:
      'Se describe, caso de paciente de 24 años por presentar dolor en la zona posteroinferior derecha, indicándose Tomografía cone beam donde se evidencia imagen isodensa distal a UD 38 con tabiques hiperdensos que establece 3 lóculos que se extiende desde el límite posterior del cuerpo mandibular hasta el tercio medio de la rama en sentido antero posterior y en sentido céfalo caudal desde la cresta alveolar hasta el límite del proceso alveolar y la basal mandibular. Se decide realizar biopsia incisional de LOE, previo a la biopsia se realizó PPAF del LOE , positivo para contenido hemático revelando dentro del estudio histopatológico, lesión tumoral quística de aspecto benigno con ortoqueratina laminar compatible con QOO seguidamente la colocación de dispositivo de descompresión rígido fijado con sutura Nylon 4-0, con recambio del dispositivo por uno de látex, posterior a 2 meses, por ulceración en mucosa yugal adyacente, después de 8 meses tras disminución de la lesión se decide realizar enucleación, osteotomía periférica y quelación con solución con carnoy dentro de la cavidad, se finalizó con la colocación de 2 coágulos de A-PRF y 2 membranas de A-PRF, síntesis de tejido, actualmente paciente se encuentra en periodo de observación.',
  },
  // 17
  {
    title:
      'UTILIDAD DE TOMOGRAFÍA COMPUTARIZADA PARA LOCALIZACION CUERPO EXTRAÑO ALOJADO EN SENO MAXILAR. REPORTE DE CASO',
    showDate: false,
    authors: [
      {
        name: 'Dueñes G',
        tag: '',
      },
      {
        name: 'Bustamante G',
        tag: '',
      },
      {
        name: 'Romero L',
        tag: '',
      },
      {
        name: 'Maria A',
        tag: '',
      },
    ],
    keywords: ['cuerpo extraño', 'seno maxilar', 'Implantes dentales'],
    tagLine: '',
    youtube: '_MJ-ZcTU0Uk',
    resumen:
      'La presencia de cuerpos extraños en el seno maxilar de cualquier origen o naturaleza es una entidad clínica poco frecuente. Su diagnóstico es habitualmente a través de estudios imagenológicos en base a la sintomatología. El tratamiento es la extracción quirúrgica del cuerpo extraño. Se trata de paciente femenina de 68 años de edad que acude a la consulta por presentar sintomatología sinusal asociada a rinorrea de lado derecho, además de presentar edentulismo total maxilar, previamente realizada su fase quirúrgica con la colocación de implantes dentales para posterior rehabilitación protésica. Por el cual se solicita una tomografía computarizada de cara. evidenciando imagen hiperdensa asociado a cuerpo extraño, en relación a la pared anterior de seno maxilar derecho, realizando bajo anestesia local el abordaje quirúrgico a través de antrostomía anterior de lado derecho, y extracción de cuerpo extraño compatible con implante dental. Culminando el procedimiento sin complicaciones. Se concluye que el apoyo diagnostico en imágenes tridimensionales ayudan al operador a la elaboración del plan quirúrgico, en este caso acortando el tiempo quirúrgico y disminuyendo la extensión del abordaje utilizado. Teniendo así resultados favorables y mayor comodidad al paciente.',
  },
  // 18
  {
    title:
      'BENEFICIOS DE LA IMAGENOLÓGIA PARA EL DIAGNOSTICO Y PLAN DE TRATAMIENTO EN LA REABSORCIÓN CONDILAR. REPORTE DE CASO',
    showDate: false,
    authors: [
      {
        name: 'Rios Elvia',
        tag: 'Residente. Postgrado de Cirugía Bucal, Facultad de Odontología, La Universidad del Zulia, Maracaibo-Venezuela.',
      },
      {
        name: 'Romero Luis M',
        tag: 'Profesor agregado. Postgrado de Cirugía Bucal, Facultad de Odontología, La Universidad del Zulia, Maracaibo-Venezuela.',
      },
      {
        name: 'Bustamante Gustavo',
        tag: 'Profesor agregado. Postgrado de Cirugía Bucal, Facultad de Odontología, La Universidad del Zulia, Maracaibo-Venezuela.',
      },
      {
        name: 'Dueñes Greyner',
        tag: 'Residente. Postgrado de Cirugía Bucal, Facultad de Odontología, La Universidad del Zulia, Maracaibo-Venezuela.',
      },
    ],
    keywords: ['Reabsorción condilar', 'articulación temporomandibular.'],
    tagLine: '',
    youtube: 'M_dsEpLfInc',
    resumen:
      'La reabsorción condilar es un trastorno degenerativo agresivo que afecta a la articulación temporomandibular (ATM) asociada a un aumento de la carga mecánica en la ATM después del tratamiento de ortodoncia, cirugía Ortognatica y traumatismos. Se evalúa describir los métodos imagenológicos empleados para el diagnóstico y manejo de la reabsorción condilar, a propósito de un caso. Se trata de Paciente femenina quien presentaba sintomatología dolorosa a nivel articular bilateral con 2 años de evolución, refiriendo antecedentes de cirugía Ortognatica. Al examen clínico se evidenció asimetría facial e hipometria oral. En la radiografía panorámica se evidenció osteolisis a nivel condilar bilateral, se solicitó una tomografía computarizada de haz cónico con reconstrucción 3D donde se corroboró pérdida de la estructura tridimensional del cóndilo; se obtuvo el archivo DICOM del complejo maxilofacial y el archivo STL el cual fue impreso en 3D, donde se realizó la planificación quirúrgica y posteriormente la impresión de los modelos estereolitográficos para la confección de las prótesis personalizadas. Conclusiones: La radiografía panorámica permite detectar signos degenerativos que son indicativos para estudios imagenológicos más especializados para determinar con exactitud la perdida de las estructuras condilares, además del uso de estas imágenes en la planificación y tratamiento ofreciendo mayor predictibilidad.',
  },
  // 19
  {
    title:
      'DIAGNÓSTICO, EVOLUCIÓN IMAGENOLÓGICA Y MANEJO MULTIDISCIPLINARIO DEL QUISTE PERIAPICAL',
    showDate: false,
    authors: [
      {
        name: 'Vasconez E',
        tag: 'Universidad de Chile, Facultad de Odontología, Especialidad en Radiología Dento Máxilo Facial Clínica Odontológica Cabezas, Quito, Ecuador.',
      },
      {
        name: 'González M',
        tag: 'Universidad de Chile, Facultad de Odontología, Especialidad en Radiología Dento Máxilo Facial Clínica Odontológica Cabezas, Quito, Ecuador.',
      },
    ],
    keywords: ['Quiste periapical', 'TCCB', 'regeneración ósea'],
    tagLine: '',
    youtube: 'RNoDbwheR6M',
    resumen:
      'El quiste periapical inflamatorio es el más común de los quiste odontogénicos, en ocaciones su diagnóstico representra un reto para el clínico, debido a que pueden alcanzar grandes tamaños y provocar una gran destrucción ósea sin presentar sintomatología previa. La imagenología de rutina en la primera consulta favorece el diagnóstco temprano y en conjunto con la tomografía de haz cónico representan un elemento importante en el tratamiento multidisciplinario de las lesiones óseas de la cavidad bucal tanto en la terapéutica como en el seguimiento evolutivo de las lesiones tratadas. Se presenta un reporte de caso de un quiste periapical de gran tamaño, como hallazgo imagenológico de pronóstico inicial reservado, con manejo multidisciplinario endodóncia, cirugía y patología, con evolución de regenración ósea total.',
  },
  // 20
  {
    title:
      'EVALUACIÓN POR IMÁGENES DE NEUROFIBROMA PLEXIFORME EN NEUROFIBROMATOSIS TIPO 1: PRESENTACIÓN DE CASO CLÍNICO',
    showDate: false,
    authors: [
      {
        name: 'Rosas Rossana R',
        tag: 'Residente del Postgrado de Cirugía Buco-Maxilofacial del Hospital Dr. Domingo Luciani.',
      },
      {
        name: 'López Rosmary',
        tag: 'Residente del Postgrado de Cirugía Buco-Maxilofacial del Hospital Dr. Domingo Luciani.',
      },
      {
        name: 'Paglia Franyelis D',
        tag: 'Residente del Postgrado de Cirugía Buco-Maxilofacial del Hospital Dr. Domingo Luciani.',
      },
      {
        name: 'Velez Henrique',
        tag: 'Cirujano Buco-Maxilofacial Adjunto y Jefe de Servicio del Postgrado de Cirugía Buco-Maxilofacial del Hospital Dr. Domingo Luciani',
      },
    ],
    keywords: [
      'Neurofibromatosis',
      'neurofibroma plexiforme',
      'enfermedad de Von Recklinghausen',
    ],
    tagLine: '',
    youtube: 'Hc5S28ABA9Q',
    resumen:
      'La enfermedad de Von Recklinghausen o neurofibromatosis tipo1 una enfermedad genética progresiva, multisistémica con afectación predominante en la piel y el sistema nervioso. El neurofibroma es un tumor benigno derivado del nervio periférico y sus envolturas, siendo los plexiformes patognomónicos de la enfermedad. Se presenta un caso de una paciente joven, que acudió al Servicio de Cirugía Buco-Maxilofacial del Hospital Dr Domingo Luciani en los que se confirmó el diagnóstico por imágenes antes de la biopsia. Se evaluó los rasgos imagenológicos del neurofibroma plexiforme a través de la tomografía computarizada con contraste que puede conducir efectivamente al diagnóstico correcto. La Imagenología mostró una compresión extraósea donde se observa una masa isodensa con vasos intralesionales y un realce heterogéneo y variable tras la inyección del medio de contraste. En conclusión, Los neurofibromas generalmente se diagnostican en estadios avanzados con compromiso de la función de los nervios involucrados o gran deformidad de partes blandas. Las imágenes juegan un papel importante en la confirmación del diagnóstico, delineando las estructuras involucradas, ayudar a precisar dónde se encuentra el tumor e identificar qué tejidos están afectados. Deben estudiarse de manera muy dirigida ya que tienen mayor riesgo de hacer una transformación maligna.',
  },
  // 21
  {
    title:
      'ANÁLISIS IMAGENOLÓGICO DE TC HELICOIDAL Y TC DE HAZ CÓNICO EN SÍNDROME TUMORAL POR HIPERPARATIROIDISMO. REPORTE DE CASO.',
    showDate: false,
    authors: [
      {
        name: 'Barrios Vannessa A',
        tag: 'Residente del Postgrado de CBMF Hospital. Dr. Domingo Luciani',
      },
      {
        name: 'Pernia Yesenia C',
        tag: 'Residente del Postgrado de CBMF Hospital. Dr. Domingo Luciani',
      },
      {
        name: 'Rosas Rossana V',
        tag: 'Residente del Postgrado de CBMF Hospital. Dr. Domingo Luciani',
      },
      {
        name: 'Velez Henrique G',
        tag: 'Especialista en Cirugía Bucomaxilofacial Hospital Dr. Domingo Luciani. Jefe del servicio de CBMF del Hosp. Dr. Domingo Luciani',
      },
    ],
    keywords: [
      'Hiperparatiroidismo',
      'síndrome tumoral por hiperparatiroidismo',
      'tomografía computarizada',
      'fibroma osificante.',
    ],
    tagLine: '',
    youtube: 'OUIDcaPNvoI',
    resumen:
      'El síndrome tumoral por hiperparatiroidismo de los maxilares son entidades poco conocidas, autosómico dominante, caracterizado por fibromas osificantes, tumores de paratiroides, quistes renales o tumores de Wilms. Aproximadamente el 90% de los pacientes diagnosticados con este síndrome, presentan hiperparatiroidismo primario, secundario a tumores paratiroideos. Así como 35% de estos presentaran fibromas osificantes en mandíbula o maxilar. Al cirujano encontrarse con este tipo de entidades es importante conocer la etiología, características clínicas, imagenológicas, compromiso sistémico. El objetivo del presente trabajo es describir un caso clínico, comparando las imágenes observadas en tomografía computarizada y tomografía de haz cónico. Caso Clínico: Paciente femenino de 26 años de edad, inicia enfermedad en Mayo del 2019, posterior a evidenciar aumento de volumen en hemicara izquierda, de crecimiento lento, progresivo, indoloro, con antecedente de tiroidectomía parcial, así como antecedente familiar de hiperparatiroidismo, acude al Hospital Dr. Domingo Luciani. Se realiza tomografía computarizada helicoidal donde se evidencia lesión isodensa, de bordes bien definidos que involucra maxilar izquierdo que desplaza órganos dentarios adyacentes, asi como también otra lesión isodensa que involucra rama mandibular izquierda con desplazamiento de órganos dentarios, con expansión de corticales óseas; y tomografía de haz cónico con lesión isodensa en las mismas regiones antes descritas con bordes difusos, poco definida, no corticalizada, se decide llevar a mesa operatoria para biopsia incisional, curetaje y osteotomía periférica. Diagnóstico: Síndrome tumoral por hiperparatiroidismo maxilar y mandibular. Plan de tratamiento: biopsia incisional, curetaje y osteotomía periférica. Seguimientos: Actualmente en control postoperatorio por nuestro servicio. Conclusiones: Con el análisis imagenológico ideal para cada caso de patologías, es posible llegar a un correcto plan de tratamiento, ofreciéndole al paciente calidad de vida.',
  },
  // 22
  {
    title:
      'EVALUACIÓN IMAGENOLÓGICA DE LA ARTICULACIÓN TEMPOROMANDIBULAR EN PACIENTE SOMETIDO A CONDILECTOMÍA COMO TRATAMIENTO DE HIPERPLASIA UNILATERAL. REPORTE DE CASO.',
    showDate: false,
    authors: [
      {
        name: 'Laguna Héctor',
        tag: 'Programa de Especialización en Cirugía y Traumatología Buco-Maxilofacial del Hospital Dr. José Gregorio Hernández- Caracas- Venezuela',
      },
      {
        name: 'Suarez Carlos',
        tag: 'Programa de Especialización en Cirugía y Traumatología Buco-Maxilofacial del Hospital Dr. José Gregorio Hernández- Caracas- Venezuela',
      },
      {
        name: 'Moleiro Katherine',
        tag: 'Programa de Especialización en Cirugía y Traumatología Buco-Maxilofacial del Hospital Dr. José Gregorio Hernández- Caracas- Venezuela',
      },
    ],
    keywords: [
      'Cóndilo mandibular',
      'articulación temporomandibular',
      'hiperplasia condilar',
      'tomografía computarizada.',
    ],
    tagLine: '',
    youtube: 'WwQE7lGhMEo',
    resumen:
      'La hiperplasia condilar unilateral (HCU) es un crecimiento excesivo, no neoplásico del cóndilo mandibular, que suele iniciarse en la pubertad y puede continuar hasta segunda o tercera década de la vida, con predilección del sexo femenino. De etiología incierta, su desarrollo paulatino puede causar prognatismo mandibular, asimetría facial y oclusal con el desplazamiento progresivo de la mandíbula hacia el lado contralateral. El propósito de este reporte fue describir un caso de HCU tratado con condilectomía alta y cirugía ortognática, con énfasis en los aspectos imagenológicos y su seguimiento post-quirúrgico tardío. En la tomografía multicorte (TM) se observaron signos de erosión, quiste subcondral, remodelación y crecimiento óseo en el cóndilo intervenido. La remodelación ósea observada en este caso, parece indicar que la cabeza mandibular mantiene su capacidad adaptativa aún en pacientes adultos, patrón similar a lo observado en los pacientes que han sido tratados quirúrgicamente.',
  },
  // 23
  {
    title:
      'TOMOGRAFÍA DE HAZ CÓNICO VS RADIOGRAFÍA PANORÁMICA PARA LOCALIZACIÓN DE TERCER MOLAR EN RELACIÓN AL CANAL MANDIBULAR. REPORTE DE CASO.',
    showDate: false,
    authors: [
      {
        name: 'Atencio Gutiérrez Maria A',
        tag: 'Postgrado de Cirugía Bucal. Facultad de Odontología. Universidad del Zulia, Maracaibo – Venezuela',
      },
      {
        name: 'Bustamante López Gustavo A',
        tag: 'Profesor agregado. Postgrado de Cirugía Bucal. Facultad de Odontología. Universidad del Zulia, Maracaibo – Venezuela.',
      },
      {
        name: 'Ríos Beltrán Elvia M',
        tag: 'Postgrado de Cirugía Bucal. Facultad de Odontología. Universidad del Zulia, Maracaibo – Venezuela',
      },
      {
        name: 'Sarcos Pérez Betsabe S',
        tag: 'Postgrado de Cirugía Bucal. Facultad de Odontología. Universidad del Zulia, Maracaibo – Venezuela',
      },
    ],
    keywords: [
      'Tomografía de haz cónico',
      'terceros molares impactados',
      'sedación consciente.',
    ],
    tagLine: '',
    youtube: 'tZwZSx5cRdI',
    resumen:
      'Las localizaciones de terceros molares mandibulares pueden resultar en variaciones anatómicas entre individuos de acuerdo a la raza y antecedentes genéticos, para ello, un exámen preoperatorio con imagenología correcta indicando la posición del canal alveolar inferior en relación con el tercer molar es etapa clave necesaria para evaluar el riesgo de una posible lesión postoperatoria del paquete vasculonervioso. Se trató de paciente femenina de 35 años quien acudió a nuestra consulta por presentar dolor en tercio inferior facial izquierdo de larga data, medicada sin presentar mejoría. A la anamnesis no refirió antecedentes médicos de relevancia. Imagenológicamente a través de radiografía panorámica se evidenció tercer molar inferior izquierdo impactado en aparente relación al canal mandibular, se decide solicitar tomografía de haz cónico multiplanar y reconstrucción 3D en la cual se observó canal mandibular en relación directa al diente retenido mencionado, se planificó procedimiento bajo sedación consciente sin complicaciones. Conclusiones: La tomografía de haz cónico es una excelente herramienta en contraste a una radiografía panorámica porque permite obtener al clínico una visión clara en las tres dimensiones del espacio de estructuras anatómicas importantes adyacentes al tercer molar, de esa manera planificar el tipo de abordaje quirúrgico y evitar complicaciones.',
  },
  // 24
  {
    title:
      'CARACTERÍSTICAS IMAGENOLÓGICAS DEL QUISTE NASOLABIAL: PRESENTACIÓN DE CASO CLÍNICO.',
    showDate: false,
    authors: [
      {
        name: 'Barrios G Vanessa A',
        tag: 'Residente del Postgrado de Cirugía Buco-Maxilofacial del Hospital General del Este Dr. Domingo Luciani',
      },
      {
        name: 'Paglia P Franyelis D',
        tag: 'Residente del Postgrado de Cirugía Buco-Maxilofacial del Hospital General del Este Dr. Domingo Luciani',
      },
      {
        name: 'Briceño Wilmar X',
        tag: 'Especialista en Cirugía Bucomaxilofacial y Coordinador del Postgrado de Cirugía Buco-Maxilofacial del Hospital General del Este Dr. Domingo Luciani',
      },
    ],
    keywords: [
      'Quiste nasoalveolar',
      'quiste nasolabial',
      'quiste maxilofacial',
    ],
    tagLine: '',
    youtube: '',
    resumen:
      'El quiste Nasolabial o Nasoalveolar es un quiste no odontogénico benigno, que se desarrolla entre el labio superior y el vestíbulo nasal, usualmente localizado entre el piso nasal anterior en la submucosa y puede desplazar medialmente el cornete inferior. El diagnóstico se realiza con el estudio histopatológico, mientras que el estudio por imagen incluye ultrasonografía, TC y resonancia magnética. Caso clínico: Paciente femenino de 36 años de edad, quien inicia enfermedad actual en septiembre del 2020, posterior a evidenciar aumento de volumen en región nasal (I), obstrucción nasal (I), motivo por el cual acude a facultativo donde es evaluada por servicio de ORL quien refiere a nuestro servicio para valoración y conducta. Al examen clínico, se evidencia aumento de volumen en hemicara izquierda, indurado, no doloroso; al examen intraoral no se evidenció aumento de volumen en fondo de vestíbulo de cuadrante II. Posteriormente, se realiza tomografía computarizada del macizo facial con cortes axiales, coronales y sagitales con reconstrucción en 3D, en donde se evidencia en un corte axial una imagen isodensa de forma redondeada, de 2x2 cm, bordes regulares, a nivel de la porción anterior del piso de la cavidad nasal, que se extiende en sentido anteroposterior desde la espina nasal anterior hasta la porción anterior del cornete nasal inferior, en relación a la porción anterior de la pared medial del seno maxilar (I). Motivo por el cual se procede, bajo anestesia local con lidocaína al 2% y epinefrina 1:80.000, realizando abordaje con incisión semilunar; a realizar biopsia excisional, siendo enviado a estudio histopatológico, el cual arroja el resultado de quiste nasolabial. Diagnóstico: Quiste nasolabial (I). Seguimientos: Actualmente en control postoperatorio por nuestro servicio, en espera de resultado imagenológico control. Conclusiones: por medio del estudio imagenológico se pudo determinar que la lesión estudiada no involucró órganos dentarios y tejido óseo, siendo una masa asociada únicamente a tejidos blandos.',
  },
  // 25
  {
    title:
      'CARACTERÍSTICAS IMAGENOLÓGICAS DEL CEMENTOBLASTOMA: PRESENTACIÓN DE CASO CLÍNICO',
    showDate: false,
    authors: [
      {
        name: 'Chourio Francisco J',
        tag: 'Residente del Postgrado de Cirugía Buco-Maxilofacial del Hospital General Del Oeste: “Dr. José Gregorio Hernández”. Magallanes de Catia',
      },
      {
        name: 'González Ana C',
        tag: 'Residente del Postgrado de Cirugía Buco-Maxilofacial del Hospital General Del Oeste: “Dr. José Gregorio Hernández”. Magallanes de Catia',
      },
      {
        name: 'Villafañe Anthony M',
        tag: 'Residente del Postgrado de Cirugía Buco-Maxilofacial del Hospital General Del Oeste: “Dr. José Gregorio Hernández”. Magallanes de Catia',
      },
      {
        name: 'De Santiago Leixer',
        tag: 'Especialista en Cirugía Bucomaxilofacial y Adjunto del Postgrado de Cirugía Buco-Maxilofacial del Hospital General Del Oeste: “Dr. José Gregorio Hernández”. Magallanes de Catia.',
      },
    ],
    keywords: ['Cementoblastoma', 'tumores odontogénicos', 'mandíbula.'],
    tagLine: '',
    youtube: 'MNoqalGuHfI',
    resumen:
      'El Cementoblastoma es un tumor mesenquimático odontogénico, representando el 1% de tumores odontogénicos. Neoplasia benigna originada a partir de cementoblastos, se presenta en jóvenes localizado principalmente en cuerpo mandibular, asociado generalmente al 1er o 2do molar. Clínicamente, puede haber dolor asociado o evoluciona asintomático. El hallazgo radiográfico es una masa radiopaca o de densidad mixta fusionada a la raíz de un diente, rodeada por un halo radiolúcido que envuelve la totalidad de la lesión. Se trata de paciente masculino de 32 años, quien refiere IEA desde el año 2008 al evidenciar dolor de leve intensidad, pulsátil, intermitente, que se intensifica con el acto masticatorio y cede a la ingesta de AINES proveniente del cuadrante IV, motivo por el cual acude a facultativo quien le realiza radiografía periapical sin presentar contributorios. En el 2009, al no evidenciar mejoría, facultativo hace restauración provisional en OD 46. En el 2013 paciente refiere tratamiento ortodóntico hasta el 2017, al continuar con dolor de leve intensidad, indican endodoncia del OD 46. Al continuar con odontalgia, Ortodoncista indica exodoncia del OD 46 en febrero 2018. Paciente no refiere mejoría y facultativo indica Rx periapical evidenciando resto radicular a nivel del espacio del OD 46, realizando su extracción. Al no presentar mejoría clínica, realizan endodoncia del OD 47 y 45 en 2020. En enero del 2021, es evaluado por Cirujano bucal quien realiza radiografía periapical e indica preparación quirúrgica para biopsia exicisional de quiste residual a nivel del espacio del OD 46, motivo por el cual es referido a nuestro centro para evaluación y conducta. En la Ortopantografía se observa IRO de aproximadamente 1cm x 1cm de longitud bordes definidos, unilocular, con la presencia de un halo radiolúcido a nivel del alvéolo del espacio del OD 46. Al examen clínico se evidencia a la palpación profunda, aumento de volumen, circunscrito de aproximadamente 1cm de diámetro, indurada, doloroso, con mucosa adyacente rosa coral característica. Diagnóstico: Cementoblastoma. Plan de tratamiento: Biopsia excisional. Actualmente en control postoperatorio, en espera de radiografía control. Conclusiones: Se comprueba mediante el estudio cronológico radiográfico, comportamiento clínico de la lesión y el estudio histopatológico, un Cementoblastoma, el cual a pesar de recibir imagenología con ausencia de OD asociado, se define el mal seguimiento previo odontológico y la importancia de la correlación clínica-radiográfica para la resolución del problema del paciente.',
  },
  // 26
  {
    title:
      'IMPORTANCIA DE LA IMAGENOLOGÌA EN EL DIAGNOSTICO DE TERATOMA REPORTE DE UN CASO CLÌNICO.',
    showDate: false,
    authors: [
      {
        name: 'Vèlez Herrique',
        tag: 'Cirujano Bucal y Maxilofacial, Jefe Director de postgrado de cirugía bucomaxilo-facial “Hospital Dr. Domingo Luciani”.',
      },
      {
        name: 'Ruiz Maria F',
        tag: 'Residente de postgrado de cirugía bucomaxilo-facial “Hospital Dr. Domingo Luciani”. Caracas – Venezuela.',
      },
      {
        name: 'Pernia Yesenia C',
        tag: 'Residente de postgrado de cirugía bucomaxilo-facial “Hospital Dr. Domingo Luciani”. Caracas – Venezuela.',
      },
      {
        name: 'Chacón Liseth E',
        tag: 'Residente de postgrado de cirugía bucomaxilo-facial “Hospital Dr. Domingo Luciani”. Caracas – Venezuela.',
      },
    ],
    keywords: [
      'Teratoma Quístico maduro',
      'tomografía computarizada',
      'resonancia magnética',
    ],
    tagLine: '',
    youtube: 'UGVnHs1RGHE',
    resumen:
      'El Teratoma Maduro es una patología que se presenta con poca frecuencia en región cráneo facial ya que en la literatura se describen con mayor frecuencia los teratomas en región sacro coccígea. En niños aparece a muy corta edad y en niñas cerca de la pubertad de localización ovárica. Los tumores de células germinales son poco frecuentes en la edad pediátrica; tienen una tasa de incidencia de 2,4 casos/millón/año y representan del 2 al 3% de cánceres en niños y adolescentes menores de 15 años por lo que la imagenologìa es indispensable para el diagnóstico precoz. Se Describió 1 caso, paciente femenina de 8 meses de edad quien con LOE en hemicara derecha. Caso Clínico: Presentamos 1 caso, paciente femenina de 8 meses de edad quien madre refiere IEA en enero 2020 posterior a evidenciar aumento de volumen en tercio medio de hemicara derecha motivo por el cual acude al Servicio para evaluación y conducta, con estudios previos donde se evaluó la Tomografía Helicoidal imagen mixta de bordes definidos isodensa e hipodensa en el centro, y en Resonancia Magnética en T1 se obtuvo imágenes hipointensa e isointensa en T2 Hiperintensa. Conclusión: La tomografía computarizada y la Resonancia Magnética ayudan a identificar la consistencia: quística o sólida, extensión de la lesión, extracraneal o intracraneal e identificar la distorsión/ afectación de los tejidos. La TC proporciona imágenes de calidad del complejo osteomeatal, destrucción ósea y los cambios en las partes blandas, como un engrosamiento mucoso. En la RM extensión tumoral o inflamatoria sobre todo la afección intracraneal y orbitaria, existencia de diseminación perineural que es incapaz de discriminar de forma adecuada la interfase tejido-aire y, por lo tanto, es inadecuada para realizar el mapa precirugía y para identificar engrosamientos sutiles de la mucosa.',
  },
  // 27
  {
    title:
      'TOMOGRAFIA DE HAZ CONICO COMO MÈTODO DE DIAGNÒSTICO TEMPRANO EN FIBROHISTIOCITOMA BENIGNO VARIANTE ANEURISMATICA REPORTE DE UN CASO',
    showDate: false,
    authros: [
      {
        name: 'Ruiz Anllert',
        tag: 'Cirujano Bucal y Maxilofacial, Adjunto  de postgrado de cirugía bucomaxilo-facial “Hospital Dr. Domingo Luciani”',
      },
      {
        name: 'Ruiz María',
        tag: 'Residente  de postgrado de cirugía bucomaxilo-facial “Hospital Dr. Domingo Luciani”',
      },
      {
        name: 'Pernia Yesenia C',
        tag: 'Residente  de postgrado de cirugía bucomaxilo-facial “Hospital Dr. Domingo Luciani”',
      },
      {
        name: 'Barrios Vannessa A',
        tag: 'Residente  de postgrado de cirugía bucomaxilo-facial “Hospital Dr. Domingo Luciani”',
      },
    ],
    keywords: [''],
    tagLine: '',
    youtube: '',
    resumen: '',
  },
  // 28
  {
    title:
      'VALOR DE LA ANGIOTOMOGRAFÍA EN LA DIFERENCIACIÓN DEL SÍNDROME DE EAGLE CLÁSICO Y EL SÍNDROME CARÓTIDOESTILOIDEO: REVISIÓN BIBLIOGRÁFICA',
    showDate: false,
    authors: [
      {
        name: 'Paglia P Franyelis D',
        tag: 'Residente de primer año del Postgrado de Cirugía Buco-Maxilofacial del Hospital Dr. Domingo Luciani',
      },
      {
        name: 'García G. Jesús A',
        tag: 'Residente de primer año del Postgrado de Cirugía Buco-Maxilofacial del Hospital Dr. Domingo Luciani',
      },
      {
        name: 'Rosas N Rossana V',
        tag: 'Residente de cuarto año del Postgrado de Cirugía Buco-Maxilofacial del Hospital Dr. Domingo Luciani',
      },
      {
        name: 'Vélez J Henrique',
        tag: 'Especialista en Cirugía Bucomaxilofacial y Director del Postgrado de Cirugía Buco-Maxilofacial del Hospital Dr. Domingo Luciani',
      },
    ],
    keywords: [
      'Apófisis estiloides',
      'ligamento estilohioideo',
      'arteria carótida interna',
      'angiotomografiía',
      'síndrome carótido-estiloideo',
    ],
    tagLine: '',
    youtube: '3VxMyUl1gHU',
    resumen:
      'El síndrome de Eagle se caracteriza por la presencia de dolor en el área orofaríngea, cervical y cara debido a una elongación de la apófisis estiloides y/o calcificación del ligamento estilohioideo. Fue descrita por Watt Ween Eagle en 1973, quien describió principalmente el síndrome de Eagle clásico, caracterizado por odinofagia, disfagia, y sensación de cuerpo extraño, y el síndrome carótido estiloideo caracterizado por dolor en la región parietal, la cara y el cuello, que aumenta con rotación lateral de la cabeza y se encuentra asociado a compresión de la arteria carótida interna o externa. El estudio por imagen ideal para su diagnóstico es la tomografía con reconstrucción en 3D, para medir las dimensiones de la apófisis. Sin embargo, no es posible estimar las relaciones anatómicas vasculares por lo que se requiere realizar angiotomografía con reconstrucción en 3D. Aún más, cuando aparecen síntomas sugestivos de síndrome carótido estiloideo. Se evaluo el conocimiento y el análisis del valor de la angiotomografía en el diagnóstico del síndrome de Eagle y planificación quirurgica. Se realizó una revisión sistemática de la literatura en la base de datos de PubMed. Conclusión: Se encontró estudios en los que se reporta disección de la arteria carótida interna secundario a la elongación de la apófisis estiloides y/o calcificacióndel ligamento estilohioideo, el cual fue diagnosticado a través de angiotomografía con reconstrucción en 3D.',
  },
  // 29
  {
    title:
      'PATRONES IMAGENOLÓGICOS EN MUCORMICOSIS RINO ORBITO CEREBRAL. SERIE DE CASOS',
    showDate: false,
    authors: [
      {
        name: 'Sarcos B',
        tag: 'Postgrado de Cirugía Bucal. Facultad de Odontología. Universidad del Zulia. Maracaibo – Venezuela',
      },
      {
        name: 'Erdody G',
        tag: 'Postgrado de Cirugía Bucal. Facultad de Odontología. Universidad del Zulia. Maracaibo – Venezuela',
      },
      {
        name: 'Bustamante G',
        tag: 'Postgrado de Cirugía Bucal. Facultad de Odontología. Universidad del Zulia. Maracaibo – Venezuela',
      },
      {
        name: 'Romero L',
        tag: 'Postgrado de Cirugía Bucal. Facultad de Odontología. Universidad del Zulia. Maracaibo – Venezuela',
      },
    ],
    keywords: [
      'Infección fúngica',
      'Mucormicosis',
      'tomografía computarizada; Mucoraceae',
    ],
    tagLine: '',
    youtube: 'hW53-RCQwhU',
    resumen:
      'La Mucormicosis es una infección micótica potencialmente mortal causada por hongos de la familia Mucoraceae cuya invasión se propaga desde la cavidad nasal y cavidades sinusales a orbita y cerebro en pacientes con comorbilidades subyacentes que afectan la función del sistema inmunológico. El objetivo es presentar las características imagenológicas observadas en pacientes con Mucormicosis Rino-Orbital a través la presentación de los casos de tres pacientes, que acudieron a consulta, con características clínicas e imagenológicas y diagnóstico histopatológico de Mucormicosis rino orbital. Ambos pacientes con antecedentes de Diabetes Mellitus tipo II y sobrevivientes de Covid-19. En los estudios imagenológicos solicitados de tipo TC de cara se evidenció reabsorción ósea a nivel de los Maxilares, engrosamiento de la mucosa de los senos maxilares y etmoidales así como también erosión y pérdida de continuidad de las paredes de los mismos. Se concluye que la Mucormicosis es una infección micótica potencialmente mortal cuya afectación más frecuente son los senos paranasales. Las imágenes tempranas son útiles para evaluar la extensión y compromiso de esta enfermedad letal que requiere un tratamiento oportuno y agresivo.',
  },
].map((item, idx) => {
  item.slug = slug(`${item.title.toLowerCase() || ''}-${idx + 1}`);
  return item;
});

exports.posters = posters;
